export enum UserManagementUserTypeEnum {
  INVITE = "invite",
  TENANT = "tenant",
}
